export default () => ({
    letterInput: '',
    init() {
        this.$watch('letterInput', value => {
            this.letterInput = value.replace(/[^a-zA-Zа-яА-ЯёЁ]/g, '');
        });
    }
})